/**
 * Stable `data-testid` values used by the end-to-end tests (the /e2e project imports this file too,
 * so the UI and the tests share one source of truth). Never reuse a value for something else.
 */
export const TEST_IDS = {
  login: {
    username: 'login-username',
    password: 'login-password',
    submit: 'login-submit',
  },
  accounts: {
    nameInput: 'account-name-input',
    typeDropdown: 'account-type-dropdown',
    createButton: 'account-create',
    name: 'account-name',
    balance: 'account-balance',
    deleteButton: 'account-delete',
    editButton: 'account-edit',
    deleteConfirm: 'account-delete-confirm',
  },
  categories: {
    nameInput: 'category-name-input',
    descriptionInput: 'category-description-input',
    iconDropdown: 'category-icon-dropdown',
    createButton: 'category-create',
    name: 'category-name',
    deleteButton: 'category-delete',
    deleteConfirm: 'category-delete-confirm',
  },
  transactions: {
    typeTabs: 'transaction-type-tabs',
    accountDropdown: 'transaction-account-dropdown',
    amountInput: 'transaction-amount-input',
    categoryDropdown: 'transaction-category-dropdown',
    descriptionInput: 'transaction-description-input',
    submitButton: 'transaction-submit',
    description: 'transaction-description',
    amount: 'transaction-amount',
    category: 'transaction-category',
    deleteButton: 'transaction-delete',
    deleteConfirm: 'transaction-delete-confirm',
  },
} as const;
